export default {"src":"/_next/static/media/electric_cat_ic.e749ba83.svg","height":120,"width":120};